import { addToGlobalThisRet } from "@plugins";

function searchMatchMark() {
    const keyWord = document.querySelector(".js-search-key-word");
    const searchTarget = document.querySelector(".js-search-target");

    if (keyWord && keyWord.innerHTML.length > 0) {
        let key = keyWord.innerHTML;

        if (key.at(0) === "«" && key.at(-1) === "»") {
            key = key.slice(1, -1);
        }

        searchTarget.innerHTML = searchTarget.innerHTML.replace(
            new RegExp(key, "g"),
            `<mark>${key}</mark>`,
        );
    }
}

window.addEventListener("load", searchMatchMark());

addToGlobalThisRet(searchMatchMark, "searchMatchMark");
